import config from '~/authentication/lib/config';
import { REQUEST_HEADERS } from '~/services/headers';
import { parseApiResponse } from '~/authentication/lib/errors';
// --- internal imports ------

async function getTradersUserData(token) {
	try {
		const baseUrl = config.userbaseServerBaseUrl;
		const result = await fetch(`${baseUrl}/api/user/`, {
			method: 'GET', 
			headers: {
				...REQUEST_HEADERS,
				'authorization': `Bearer ${token}`
			},
			signal: AbortSignal.timeout(15000)
		});

		const jsonResponse = await parseApiResponse(result, 'Failed to fetch user data');

		return jsonResponse?.data?.user;
	}
	catch(e) {
		console.error('getTradersUserData Error encountered.');
		throw e; // Bubble up the error instead of quietly returning null
	}
}

export default getTradersUserData;
